import React, { useMemo, useState } from "react";
import { useGetCustomersQuery } from "state/api";
import {
  PageContainer,
  DataTable,
  TableToolbar,
  StatusChip,
  normalizeList,
  formatCurrency,
} from "components/shared";

const Customers = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0); // 0-based for TablePagination
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const { data, isFetching } = useGetCustomersQuery({
    page: page + 1,
    limit: rowsPerPage,
    search,
  });

  const { rows, total } = useMemo(
    () => normalizeList(data, { page: page + 1, pageSize: rowsPerPage }),
    [data, page, rowsPerPage]
  );

  const columns = useMemo(
    () => [
      {
        field: "name",
        headerName: "Name",
        render: (c) => c.name || "—",
      },
      {
        field: "phoneNo",
        headerName: "Phone",
        render: (c) => c.phoneNo || "—",
      },
      {
        field: "email",
        headerName: "Email",
        render: (c) => c.email || "—",
      },
      {
        field: "city",
        headerName: "City",
        render: (c) => c.address?.city || "—",
      },
      {
        field: "category",
        headerName: "Category",
        render: (c) => (c.category ? <StatusChip status={c.category} /> : "—"),
      },
      {
        field: "currentCredit",
        headerName: "Credit",
        align: "right",
        render: (c) =>
          c.currentCredit != null ? formatCurrency(c.currentCredit) : "—",
      },
      {
        field: "status",
        headerName: "Status",
        render: (c) => (c.status ? <StatusChip status={c.status} /> : "—"),
      },
    ],
    []
  );

  return (
    <PageContainer title="Customers" subtitle="List of customers">
      <TableToolbar
        search={search}
        onSearchChange={(v) => {
          setSearch(v);
          setPage(0);
        }}
        searchPlaceholder="Search by name, phone or email…"
      />
      <DataTable
        columns={columns}
        rows={rows}
        loading={isFetching}
        emptyText="No customers found"
        page={page}
        rowsPerPage={rowsPerPage}
        total={total}
        onPageChange={setPage}
        onRowsPerPageChange={(n) => {
          setRowsPerPage(n);
          setPage(0);
        }}
      />
    </PageContainer>
  );
};

export default Customers;
